import React from 'react';
import { Helmet } from 'react-helmet';

export default function Base64EncodingGuide() {
  return (
    <main className="container mx-auto px-4 py-12">
      <Helmet>
        <title>Base64 Encoding & Decoding - Beginner's Guide | WebUtility</title>
        <meta name="description" content="Learn how Base64 encoding works and how to easily encode or decode text using WebUtility's free Base64 tool." />
      </Helmet>

      <h1 className="text-3xl font-bold mb-4">Base64 Encoding & Decoding: Beginner's Guide</h1>
      <p className="mb-4 text-gray-600">
        Base64 is a common way to encode binary data (like images) into plain text, so it can be easily transmitted or stored. Let's explore how to use Base64 and decode it.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">How to Encode Text with Base64</h2>
      <ol className="list-decimal ml-6">
        <li>Open our <a href="/base64" className="text-blue-600 underline">Base64 Encoder Tool</a>.</li>
        <li>Paste your text or upload a file.</li>
        <li>Select <strong>"Encode"</strong> and click Convert.</li>
        <li>Copy the resulting Base64 string.</li>
      </ol>

      <h2 className="text-2xl font-semibold mt-6 mb-2">How to Decode Base64</h2>
      <ol className="list-decimal ml-6">
        <li>Paste the Base64 string into the input box.</li>
        <li>Select <strong>"Decode"</strong>.</li>
        <li>Click Convert to see the original text.</li>
      </ol>

      <h2 className="text-2xl font-semibold mt-6 mb-2">When to Use Base64?</h2>
      <ul className="list-disc ml-6">
        <li>Embed small images directly into HTML/CSS.</li>
        <li>Transfer binary files over text-based protocols (like JSON or XML).</li>
        <li>Store binary data in databases.</li>
      </ul>
    </main>
  );
}
